<template>
	<el-dialog title="关联联系人" :visible.sync="dialogVisible" width="550px" :before-close="handleClose" :append-to-body="true">
		<div class="talent-info">
			<el-image :src="row.head" />
			<div class="right">
				<div class="ellipsis">
					<platform-icon class="mr-8" :platformId="row.platform_id"></platform-icon>
					{{ row.anchor_name }}
				</div>
				<div class="number">
					<div class="ellipsis">{{ row.platform_id | formatPlatformName('unify') }}： {{ anchorAccount }}</div>
				</div>
			</div>
		</div>
		<el-radio-group class="mt-16 el-radio-group" v-model="isContact">
			<el-radio :label="0">关联已有联系人</el-radio>
			<el-radio :label="1">新建联系人</el-radio>
		</el-radio-group>
		<el-form :model="form" :rules="rules" ref="ruleForm" label-width="110px">
			<template v-if="isContact">
				<el-form-item label="微信号" prop="wechat_account" key="wechat_account">
					<el-input v-model="form.wechat_account" placeholder="请输入微信号" maxlength="32" />
				</el-form-item>
				<el-form-item label="名称" prop="contact_name" key="contact_name">
					<el-input v-model="form.contact_name" placeholder="请输入名称" />
				</el-form-item>
				<el-form-item label="手机号" key="mobile">
					<el-input v-model="form.mobile" placeholder="请输入手机号" />
				</el-form-item>
				<el-form-item label="添加微信" prop="is_add_wx" key="is_add_wx">
					<el-radio-group v-model="form.is_add_wx">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注" style="margin: 0" key="remark">
					<el-input v-model="form.remark" placeholder="请输入备注" />
				</el-form-item>
			</template>
			<el-form-item label="请选择联系人" style="margin: 0" prop="id" label-width="110px" key="id" v-else>
				<el-select
					v-model="form.id"
					filterable
					remote
					:remote-method="getTalentContactList"
					@focus="getTalentContactList()"
					:loading-text="loadingText"
					:loading="loading"
					clearable
					placeholder="请选择 / 搜索联系人"
				>
					<template v-slot:prefix>
						<i class="el-icon-search ml-4"></i>
					</template>
					<el-option
						v-for="(item, index) in linkmanList"
						:key="index"
						:label="`${item.contact_name || ''}${item.contact_name && item.nick_name ? '-' : ''}${item.nick_name || ''}`"
						:value="item.id"
					/>
				</el-select>
			</el-form-item>
		</el-form>
		<span slot="footer">
			<el-button type="primary" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { talentContact, addContactPerson, getTalentContactList } from '@/api/talentCRM';

export default {
	name: 'linkmanDialog',
	data() {
		return {
			dialogVisible: false,
			isContact: 0,
			linkmanList: [],
			contactForm: {},
			row: {},
			form: {
				id: '',
				wechat_account: '',
				contact_name: '',
				mobile: '',
				remark: '',
				is_add_wx: '1',
			},
			rules: {
				id: { required: true, message: '请选择联系人', trigger: 'change' },
				is_add_wx: { required: true, message: '请选择', trigger: 'change' },
				wechat_account: [
					{ required: true, message: '请输入微信号', trigger: 'blur' },
					// { required: true, validator: checkWx, trigger: 'blur' }
				],
				contact_name: { required: true, message: '请输入名称', trigger: 'change' },
			},
			loading: false,
			loadingText: '加载中',
			addId: '',
		};
	},
	methods: {
		show(form, row, isContact) {
			this.contactForm = form;
			this.row = row;
			this.isContact = isContact || 0;
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
			this.linkmanList = [];
			this.isContact = 0;
			this.contactForm = {};
			this.row = {};
			this.form = {
				id: '',
				wechat_account: '',
				contact_name: '',
				mobile: '',
				remark: '',
				is_add_wx: '1',
			};
			this.addId = '';
			this.$refs.ruleForm.resetFields();
		},
		async getTalentContactList(name = '') {
			this.loading = true;
			this.loadingText = '加载中';
			const { code, data: { list = [] } = {} } = await getTalentContactList({ name });
			if (code !== 0) return;
			this.linkmanList = list;
			list.length ? (this.loading = false) : (this.loadingText = '无数据');
		},
		submit() {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { isContact, form, contactForm } = this;
				let id = form.id;
				if (isContact) {
					const { wechat_account, contact_name, mobile, remark, is_add_wx } = form;
					const { anchor_id } = contactForm;
					const { code, data } = await addContactPerson({
						wechat_account,
						contact_name,
						mobile,
						remark,
						anchor_id,
						is_add_wx,
					});
					if (code !== 0) return;
					id = data.id;
					this.addId = data.id;
				}
				const params = {
					id,
					...contactForm,
					operate_time: Math.trunc(contactForm.operate_time / 1000),
				};
				if (isContact) {
					params.is_add_wx = this.form.is_add_wx;
				}
				const { code } = await talentContact(params);
				if (code !== 0) return;
				this.$message.success('建联成功');
				this.$emit('getList');
				this.$emit('onInject', { id: this.addId, contact_name: this.form.contact_name });
				this.handleClose();
			});
		},
	},
	computed: {
		anchorAccount() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.row.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.row.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.row.anchor_uid,
			};
			return temPF[this.row.platform_id];
		},
	},
	components: {},
};
</script>

<style lang="less" scoped>
.el-radio-group {
	margin-left: 5px;
}
.el-form {
	padding: 16px;
	background-color: #f8f8f8;
	border-radius: 4px;
	margin-top: 16px;
}
.talent-info {
	display: flex;
	align-items: center;
	.el-image {
		width: 52px;
		height: 52px;
		border-radius: 50%;
	}
	.right {
		margin-left: 8px;
		font-size: 14px;
		color: #666;
		flex: 1;
		overflow: hidden;
		.ellipsis {
			color: #333;
		}
		.number {
			display: flex;
			align-items: center;
			margin-top: 4px;
			.ellipsis {
				flex: 1;
				overflow: hidden;
				color: #666;
			}
		}
	}
}
.el-radio-group {
	/deep/ .el-radio {
		font-weight: 400 !important;
	}
}
/deep/ .el-select {
	.el-select__caret:first-child::before {
		content: '\e6e1';
	}
	.is-focus {
		.el-select__caret:first-child {
			transform: rotateZ(0deg);
		}
	}
}
</style>
